import { defineComponent as _defineComponent } from 'vue'
import {
  BillingDetailsFormType,
  billingFormValidations,
  buildBillingForm,
} from '@/lib/billing/billingFormSpec';
import { countries } from '@/lib/country-data/countries';
import { getErrorMessages } from '@/plugins/vuelidate';
import useVuelidate from '@vuelidate/core';
import { reactive } from 'vue';
import { BillingDetails } from '../../../api/v1';
import InputGroup from '../form/InputGroup.vue';
import AutoComplete from '../inputs/AutoComplete.vue';
import TextInput from '../inputs/TextInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BillingForm',
  props: {
    billingDetails: null,
    useMasonryLayout: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { billingDetails: BillingDetails | null, useMasonryLayout: boolean }



const countryList = countries;

const form = reactive<BillingDetailsFormType>(
  buildBillingForm(props.billingDetails),
);
const validations = reactive(billingFormValidations);

const v$ = useVuelidate(validations, form, {
  $autoDirty: true,
  $registerAs: 'billing-form',
});

return { __sfc: true,props, countryList, form, validations, v$, getErrorMessages, InputGroup, AutoComplete, TextInput }
}

})